import { CheckCircle2 } from "lucide-react";

const TeamSection = () => (
  <section className="py-16 md:py-20 bg-gradient-to-b from-white to-[#F8F9FA]">
    <div className="max-w-4xl mx-auto px-5 md:px-12 text-center">
      <h2 className="text-2xl sm:text-3xl font-bold text-[#0A2540] tracking-tight mb-3 leading-tight">
        合作後怎麼分工？<br className="md:hidden" />
        <span className="text-[#FF6B00]">行銷、接單、客服我們全包</span>，您專心顧好現場
      </h2>
      <p className="text-sm text-[#475569] mb-8">月付方案與保障分潤方案，都是與業主分工合作</p>

      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <div className="bg-white rounded-2xl p-6 shadow-md border-l-4 border-[#FF6B00]">
          <div className="text-lg font-bold text-[#FF6B00] mb-3">人客多負責</div>
          <div className="space-y-2 text-sm text-left text-[#475569]">
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>6-8 人精英行銷小編，為您宣傳、接單、客服細節回覆</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>產品定位與客群建構</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>更成功的定價策略，價格更高卻賣得更多</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>行銷廣告投放與優化</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>網紅導流（KOL 合作）</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>FB / IG / LINE@ 建置與經營</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>客服接單（10:00-23:00，解放業主時間）</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>OTA 平台管理與定價策略</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#FF6B00] flex-shrink-0 mt-0.5" /><span>Google 評論管理與優化</span></div>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-md border-l-4 border-[#0A2540]">
          <div className="text-lg font-bold text-[#0A2540] mb-3">業主負責</div>
          <div className="space-y-2 text-sm text-left text-[#475569]">
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#0A2540] flex-shrink-0 mt-0.5" /><span>管家人事管理</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#0A2540] flex-shrink-0 mt-0.5" /><span>現場物業維護</span></div>
            <div className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#0A2540] flex-shrink-0 mt-0.5" /><span>銀行收款對帳</span></div>
          </div>
        </div>
      </div>

      <div className="inline-block bg-[#FF6B00] text-white font-bold text-sm px-8 py-3 rounded-full shadow-lg">
        已有多個成功案例，營收增加 90%~450%
      </div>
    </div>
  </section>
);

export default TeamSection;
